import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
}
export const CTAButton: React.FC<CTAButtonProps> = ({
  children,
  className = ''
}) => {
  return <a href="https://clavedepaz.com/cart/44141169541219:1" className={`inline-block w-full md:w-auto text-center bg-terracotta hover:bg-terracotta-hover text-white font-sans font-bold text-lg md:text-xl py-4 px-8 rounded-xl shadow-lg shadow-terracotta/30 transition-all duration-300 hover:scale-[1.02] active:scale-[0.98] ${className}`} data-id="element-63">
      {children}
    </a>;
};